import { Col, Row } from 'antd'
import * as React from 'react'

import Link from '../DataSheet/Link'
import Pricing from './Pricing'

const titleClassName = 'text-black mb-0'

type Props = {
  title?: React.ReactNode
  textClassName?: string
}

const ProductItemName: React.FC<MemberProps<IProductRequestItem, Props>> = ({
  member,
  props: { title, textClassName } = {}
}) => {
  const className = textClassName || titleClassName
  const name = member.product_name || member.item.name
  const { category_segment_name } = member.item

  return (
    <Row gutter={[8, 8]}>
      <Col flex="auto" className="d-flex">
        <Row className="full-width">
          <Col span={24} className="d-flex justify-content-between">
            {title ? title : <h3 className={className}>{category_segment_name}</h3>}
          </Col>
          <Col span={24} className="d-flex justify-content-between">
            <h6 className={className}>
              <span>{name}</span>
            </h6>
            <Pricing member={member} />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Link url={member.data_sheet_url} title={member.product_name} />
      </Col>
    </Row>
  )
}

export default ProductItemName
